import { render, staticRenderFns } from "./SnapshotCheck.vue?vue&type=template&id=2fc10c08&scoped=true&"
import script from "./SnapshotCheck.vue?vue&type=script&lang=ts&"
export * from "./SnapshotCheck.vue?vue&type=script&lang=ts&"
import style0 from "./SnapshotCheck.vue?vue&type=style&index=0&id=2fc10c08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc10c08",
  null
  
)

export default component.exports